import SettingsLayout from '@/layouts/SettingsLayout/SettingsLayout'
import { createFileRoute, Outlet, useLocation } from '@tanstack/react-router'

import useTeamSettingsLinks from '@/layouts/SettingsLayout/hooks/useTeamSettingsLinks'

export const Route = createFileRoute('/$workspaceName/$environment/team-settings')({
  component: SettingsLayoutRoute,
})

function SettingsLayoutRoute() {
  const location = useLocation()
  const { links } = useTeamSettingsLinks({ pathname: location.pathname })

  return (
    <SettingsLayout key={location.pathname} title={'Team Settings'} links={links}>
      <Outlet />
    </SettingsLayout>
  )
}
